import { addDays, endOfDay, startOfDay } from '~/util/date';

import { getAdmissionOptions } from '@generated';
import { useSuspenseQuery } from '@tanstack/react-query';
import { Section } from '~/shared/section/Section';
import { convertFrequenciesToCalendarEvent } from '~/features/frequencies/util';
import { useSearch } from '~/util/http/useSearch';
import { FiveDayTimeline } from '~/shared/calendar/FiveDayTimeline';
import { SectionTitle } from '~/shared/section/SectionTitle';

export function StartOfCareSchedule({ stayId }: { stayId: string }) {
	const { data: admission } = useSuspenseQuery(getAdmissionOptions(stayId));
	const startscheduledDateAndTime = startOfDay(admission.startOfCareDate);
	const endscheduledDateAndTime = endOfDay(addDays(admission.startOfCareDate, 4));
	const { data: visits } = useSearch({
		searchType: 'frequency',
		filters: [
			{ name: 'stayId', operator: '==', value: stayId },
			{ name: 'scheduledDateAndTime', operator: '>=', value: startscheduledDateAndTime },
			{
				name: 'scheduledDateAndTime',
				operator: '<=',
				value: endscheduledDateAndTime
			}
		],
		pageSize: 1000
	});

	return (
		<Section header={<SectionTitle title="Start of Care Schedule" />}>
			<FiveDayTimeline startDate={admission.startOfCareDate} events={convertFrequenciesToCalendarEvent(visits)} allowDragAndDrop />
		</Section>
	);
}
